import PropTypes from 'prop-types';
import React from 'react';

import { useGetLocalization } from '../../../../hooks';
import { InputDate } from '../../../reusable';

function DateRangeSelect({ endDate, setEndDate, setStartDate, startDate, maxDate, minDate }) {
  const getLocalization = useGetLocalization();
  return (
    <>
      <InputDate
        isRequired
        id="ReconciliationSummariesStartDate"
        label={getLocalization('lbl.earliest-search-date')}
        value={startDate}
        onChange={setStartDate}
        maxDate={maxDate}
        minDate={minDate}
      />
      <InputDate
        isRequired
        id="ReconciliationSummariesEndDate"
        label={getLocalization('lbl.latest-search-date')}
        value={endDate}
        onChange={setEndDate}
        maxDate={maxDate}
        minDate={minDate}
      />
    </>
  );
}

DateRangeSelect.propTypes = {
  endDate: PropTypes.string.isRequired,
  setEndDate: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  maxDate: PropTypes.string.isRequired,
  minDate: PropTypes.string.isRequired,
};

export default DateRangeSelect;
